import { useTranslation } from "react-i18next";
import Skeleton from "@mui/material/Skeleton";
import DataNotFound from "components/DataNotFound";
import BarsGroupChart, { dataValue } from "components/BarsGroupChart";
import { Typography } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { selectIsAssignmentUsageLoading } from "features/Reports";

const customStyles = {
  chartContainer: {
    width: "100%",
    paddingTop: "2rem",
    height: 275,
    padding: "20px",
    direction: "ltr",
    "@media screen and (max-width: 1023px)": {
      "& *": {
        fontSize: "10px !important",
      },
    },
    "@media print": {
      height: "90mm",
      width: "100%",
      breakInside: "avoid",
      colorAdjust: "exact",
      pageBreakBefore: "avoid",
      pageBreakAfter: "avoid",
    },
  },
};

interface ILessonsDataProps {
  data: dataValue[];
}
function LessonsChartSection({ data }: ILessonsDataProps) {
  const isAssignmentUsageLoading = useAppSelector(
    selectIsAssignmentUsageLoading
  );
  const { t } = useTranslation();
  const dataKeys = [
    {
      label: t("lessonsAssigned"),
      color: "rgb(26, 45, 96)",
      legendColor: "rgb(26, 45, 96)",
    },
    {
      label: t("lessonsCompleted"),
      color: "rgb(108, 124, 169)",
      legendColor: "rgb(108, 124, 169)",
    },
  ];

  return (
    <Typography component="div" sx={customStyles.chartContainer}>
      {isAssignmentUsageLoading ? (
        <Skeleton variant="rectangular" height={250} />
      ) : data.length ? (
        <BarsGroupChart
          dataKeys={dataKeys}
          data={data}
          xAxisLabel="xAxisLabel"
          barCategoryGap="30%"
          cursorValue="default"
          label="top"
          radius={[5, 5, 0, 0]}
          legendSize="small"
        />
      ) : (
        <DataNotFound text={t("No data")} />
      )}
    </Typography>
  );
}

export default LessonsChartSection;
